import { create } from "zustand";

// Non-PII onboarding state only. ID number / address live in the encrypted vault (lib/secureStore).
interface OnboardingState {
  fullName: string;
  phone: string;
  verified: boolean;
  idLast4: string;
  setPersonal: (data: { fullName: string; phone: string }) => void;
  markVerified: (idLast4: string) => void;
}

export const useOnboardingStore = create<OnboardingState>((set) => ({
  fullName: "",
  phone: "",
  verified: false,
  idLast4: "",
  setPersonal: (data) => set(data),
  markVerified: (idLast4) => set({ verified: true, idLast4 }),
}));
